import { valueGroupValidator } from "../../models/schemasV2";
import { z } from "zod";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { HandleAttributeValueGroupActionParams } from "../../hooks/templateV2/types";
import SingleValuePopover from "./SingleValuePopover";

interface SingleValueGroupsProps {
  valueGroup: z.infer<typeof valueGroupValidator>;
  handleAttributeValueGroupAction: (
    data: HandleAttributeValueGroupActionParams,
  ) => void;
}
export const SingleValueGroups = ({
  valueGroup,
  handleAttributeValueGroupAction,
}: SingleValueGroupsProps) => {
  return (
    <div className="flex flex-col gap-2" key={valueGroup.id}>
      {valueGroup.attributes.map((attribute) => (
        <Popover key={attribute.id}>
          <PopoverTrigger asChild>
            <div
              className="flex w-80 gap-2 p-2 border border-stone-200 cursor-pointer"
              key={attribute.id}
            >
              <div className="text-sm truncate">{attribute.name}</div>
            </div>
          </PopoverTrigger>
          <PopoverContent className="w-[500px]" align="start">
            <SingleValuePopover
              onSave={handleAttributeValueGroupAction}
              valueGroupId={valueGroup.id}
              attribute={attribute}
            />
          </PopoverContent>
        </Popover>
      ))}
    </div>
  );
};
